module.exports = __webpack_public_path__ + "62zMRbUQkDDyPCw-E/rdc_pro_logo.svg";